import { useLocale } from '~/contexts/LocaleContext'
import { getTranslation } from '~/lib'
import { IconTimeOutSvg } from '~/icons/ic_time_out'
import { useBookingCart } from '~/stores/booking-cart'
import { useCancelBooking } from '~/hooks/use-booking'
import Card from '~/components/ui/card'
import { BookingStep, useBookingFlow } from '~/stores/booking-flow'
import { useRouter } from 'next/navigation'

interface TimeoutDeadlineProps {
  hotelId: string
  dataPayment?: any
}

export default function TimeoutDeadline({ hotelId, dataPayment }: TimeoutDeadlineProps) {
  const { clearCart } = useBookingCart()
  const { cancelBooking } = useCancelBooking()
  const { locale } = useLocale()
  const t = getTranslation(locale)
  const { setCurrentStep, setCurrentPaymentStep } = useBookingFlow()
  const clearMinutesLeft = () => {
    localStorage.removeItem('PaymentDeadline')
  }

  const handleBackToHome = () => {
    // cancelBooking({
    //   hotelId: Number(hotelId),
    //   bookingId: dataPayment?.bookingNo || '',
    //   reason: 'Timeout Payment cancelled the booking',
    // })
    // setCurrentStep(BookingStep.LIST)
    // setCurrentPaymentStep(1)
    clearCart()
    clearMinutesLeft()
    const HOME = process.env.NEXT_PUBLIC_PORTAL_URL
    window.location.href = `${HOME}/${locale}`
  }

  const handleRetryBooking = () => {
    // cancelBooking({
    //   hotelId: Number(hotelId),
    //   bookingId: dataPayment?.bookingNo || '',
    //   reason: 'Timeout Payment cancelled the booking',
    // })
    const params = new URLSearchParams()
    params.set('hotelId', hotelId)
    params.set('checkInDate', dataPayment?.arrivalDate || '')
    params.set('checkOutDate', dataPayment?.departureDate || '')
    params.set('adults', String(dataPayment?.cardItems?.[0]?.guests?.adults || 1))
    params.set('kidsOver6', String(dataPayment?.cardItems?.[0]?.guests?.children6To12 || 0))
    params.set('kidsUnder6', String(dataPayment?.cardItems?.[0]?.guests?.childrenUnder6 || 0))
    // clearCart()
    setCurrentStep(BookingStep.LIST)
    setCurrentPaymentStep(1)
    clearMinutesLeft()
    window.location.href = `/?${params.toString()}`
  }
  return (
    <Card className="xs:mb-4 max-w-[520px] p-4 pt-4" padding={0}>
      <div className={`mx-auto w-full`}>
        <div className="mb-3 grid justify-center text-center text-[#2D2E32]">
          <span className="mx-auto mb-3">
            <IconTimeOutSvg />
          </span>
          <label className="my-1 text-[20px] font-medium">{t('payment.timeout')}</label>
          <label className="mb-1 text-sm font-[350] text-[#2D2E32]">
            {t('payment.timeoutMsg')}
          </label>
        </div>
        <div className="mt-6 flex gap-3">
          <button
            onClick={handleBackToHome}
            className="flex w-full items-center justify-center gap-2 rounded bg-[#EBE3D6] p-3 text-base text-typo-brand"
          >
            {t('payment.backToHome')}
          </button>
          <button
            onClick={handleRetryBooking}
            className="flex w-full items-center justify-center gap-2 rounded bg-primary-500 p-3 text-base text-white"
          >
            {t('payment.retryBooking')}
          </button>
        </div>
      </div>
    </Card>
  )
}
